import script from "./ProjectTableItem.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectTableItem.vue?vue&type=script&setup=true&lang=js"

import "./ProjectTableItem.vue?vue&type=style&index=0&id=710ebdd1&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-710ebdd1"]])

export default __exports__